import { render, staticRenderFns } from "./SearchTipsInfo.vue?vue&type=template&id=461d4cd6&"
import script from "./SearchTipsInfo.vue?vue&type=script&lang=js&"
export * from "./SearchTipsInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchTipsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports